import {isNullOrUndefined} from "../../../../services/Validator";
import SystemScreenError from "../../../errors/SystemScreenError";
import {kExerciserCorrectionError} from "../../../../constants/errors";
import ExerciserCorrectionQuestionText from "../../../texts/courses/exercisers/ExerciserCorrectionQuestionText";
import ExerciserCorrectionCard from "../../../cards/courses/exercisers/ExerciserCorrectionCard";
import FlashCorrectionContentLayout from "../../../layouts/courses/flash/FlashCorrectionContentLayout";
import SystemQuestionKnowledge from "../../SystemQuestionKnowledge";
import {get_nested} from "../../../../services/JsonHandler";

export default function ExerciserCorrectionContent({question, levelA}) {
    // Used in ExerciserCorrectionScreen to display core content made of
    // question text, user answer, correction, and corresponding advice

    // PROPERTIES
    const questionKnowledge = get_nested(['levelAKnowledge'], levelA, null)

    // BUILD
    if (isNullOrUndefined(question))
        return <SystemScreenError error={kExerciserCorrectionError} />
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col items-center"}>
            <FlashCorrectionContentLayout>
                <ExerciserCorrectionQuestionText question={question.question} />
                <SystemQuestionKnowledge knowledge={questionKnowledge} />
                <ExerciserCorrectionCard userSubmission={question.userSubmission}
                                         isCorrect={question?.userSubmission?.isCorrect}
                                         correction={question.correction} />
            </FlashCorrectionContentLayout>
        </div>
    );
}